module.exports = __webpack_public_path__ + "img/company-culture.75b6e16d.png";